


























import Vue from 'vue'

export interface BreadcrumbInterface {
  translate: string,
  to: string,
  linkValueToForward?: string[]|undefined
}

export default Vue.extend({
  name: 'AppBreadcrumb',
  computed: {
    breadcrumbs(): BreadcrumbInterface {
      return this.$route.meta.breadcrumb
    },
  },
  methods: {
    dynamicTextIfNeeded(item: BreadcrumbInterface) {
      return this.$t(item.translate, this.$route.params)
    },
    dynamicRouteIfNeeded(item: BreadcrumbInterface) {
      if (typeof item.linkValueToForward === 'undefined') {
        return item.to
      }

      let tmpRoute = item.to

      item.linkValueToForward.forEach(param => {
        tmpRoute = tmpRoute.replace(`{{${param}}}`, this.$route.params[param])
      })

      return tmpRoute
    },
  },

})
